<template>
  <v-text-field
    v-if="!hasEnabledAddressSearch"
    :label="$t('createErrand.streetAddress')"
    v-model="address"
    :rules="validationRules"
  ></v-text-field>
  <v-combobox
    v-else
    class="visible-icon search"
    autocomplete="new-password"
    v-model="address"
    :items="items"
    :loading="isLoading"

    hide-no-data
    hide-selected
    prepend-icon="search"
    append-icon=""
    :item-text="getText"
    item-value="place_id"
    :clearable="true"
    :label="$t('createErrand.streetAddress')"
    :no-filter="true"
    :rules="validationRules"
    :search-input.sync="query"
    :return-object="true"
    :chips="hasAddressId"
    :readonly="hasAddressId"
  ></v-combobox>
</template>

<script>
import rpcService from '@/core/services/rpc-service'
import _ from 'lodash'
import localizationService from '@/core/services/localization-service'
import utils from '@/core/utils'

export default {
  props: ['eventKey'],
  data: () => ({
    query: null,
    pendingSearch: null,
    items: [],
    address: null
  }),
  methods: {
    getText(item) {
      return `${item.name} - ${item.address} - ${item.city}`
    }
  },
  watch: {
    query(query) {
      if (this.isLoading) {
        this.pendingSearch.abort()
      }
      if (!query || query.length < 3) {
        this.items = []
        return
      }
      this.pendingSearch = rpcService
        .searchAddress({
          address: utils.replaceSpacesWithWildcards(query),
          countryCode: localizationService.getCountryByCompany(
            this.currentUserCompany
          )
        })
        .done(result => {
          this.items = result
        })
    },
    address(value) {
      this.publish(`address.${this.eventKey}.changed`, value || null)
    }
  },
  computed: {
    isLoading() {
      return !!(this.pendingSearch && this.pendingSearch.readyState < 4)
    },
    hasEnabledAddressSearch() {
      return this.hasFeature('useAddressSearch')
    },
    hasAddressId() {
      return _.has(this.address, 'place_id')
    },
    addressText() {
      return this.hasEnabledAddressSearch ? this.query : this.address
    },
    validationRules() {
      return [
        v => {
          return (
            !!(this.query || this.address) ||
            this.$t('createErrand.requiredField')
          )
        }
      ]
    }
  }
}
</script>
